import { SeasonProcessState, SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { RuleSet, SeasonPlan } from '@coin/shared/core/util-models';
import { GenericSeasonSettings, Season } from '@coin/shared/season-mgmt/util';
import { SeasonSimulation } from '../models/season-simulation.model';
import { SeasonProcessStepNav } from '../interfaces/season-process-step-nav.interface';

export class SetCurrentProcessStep {
  static readonly type = '[Season] Set Current Process Step';

  constructor(public readonly payload: string) {}
}

export class NextProcessStep {
  static readonly type = '[Season] Next Process Step';
}

export class PrevProcessStep {
  static readonly type = '[Season] Prev Process Step';
}

export class UpdateProcessStep {
  static readonly type = '[Season] Update Process Step';
  constructor(public readonly payload: Partial<SeasonProcessStepNav> & { id: SeasonProcessStepNav['id'] }) {}
}

export class SetSeasonState {
  static readonly type = '[Season] Set Season State';

  constructor(public readonly payload: SeasonProcessState) {}
}

export class SetPlanVersion {
  static readonly type = '[Season] Set Plan Version';

  constructor(public readonly payload: number) {}
}

export class SetPlan {
  static readonly type = '[Season] Set Plan';

  constructor(public readonly payload: SeasonPlan) {}
}

export class SetRuleSet {
  static readonly type = '[Season] Set Rule Set';

  constructor(public readonly payload?: RuleSet) {}
}

export class LoadSimulations {
  static readonly type = '[Season] Load Simulations';

  constructor(public readonly payload: { seasonId: string; seasonType: SeasonTypeEnum }) {}
}

export class ResetCurrentSeason {
  static readonly type = '[Season] Reset Current Season';
}

export class ResetCurrentSimulation {
  static readonly type = '[Season] Reset Current Simulation';
}

export class ResetCurrentPlan {
  static readonly type = '[Season] Reset Current Plan';
}

export class SetPlans {
  static readonly type = '[Season] Set Plans';

  constructor(public readonly payload: SeasonPlan[]) {}
}

export class UpdatePlanTitle {
  static readonly type = '[Season] Update Plantitle';

  constructor(
    public readonly payload: { plan: SeasonPlan; newTitle: string; displayName: string; seasonType: SeasonTypeEnum }
  ) {}
}

export class UpdateSeasonPlan {
  static readonly type = '[Season] Update Plan';

  constructor(public readonly payload: SeasonPlan) {}
}

export class DeletePlan {
  static readonly type = '[Season] Delete Plan';

  constructor(public readonly payload: { plan: SeasonPlan; seasonType: SeasonTypeEnum }) {}
}

export class SetCurrentPlan {
  static readonly type = '[Season]Set Current Plan';

  constructor(public readonly payload: { seasonId: string; seasonType: SeasonTypeEnum; planId: string }) {}
}

export class SetCurrentSeason {
  static readonly type = '[Season] Set Current Season';

  constructor(
    public readonly seasonId: string,
    public readonly seasonType: SeasonTypeEnum
  ) {}
}

export class UpdateCurrentSeason {
  static readonly type = '[Season] Update Current Season';

  constructor(public readonly payload: Season) {}
}

export class UpdateSpecialPaymentSeasonState {
  static readonly type = '[Season] Update State for Special Payment Season';

  constructor(
    public readonly seasonId: string,
    public readonly newState: SeasonProcessState.Monitoring | SeasonProcessState.Evaluation
  ) {}
}

export class UpdateExceptionalRecognitionSeasonState {
  static readonly type = '[Season] Update State for Exceptional Recognition Season';

  constructor(
    public readonly seasonId: string,
    public readonly newState: SeasonProcessState
  ) {}
}

export class SetCurrentSeasonSettings {
  static readonly type = '[Season] Set Current Season Settings';
}

export class UpdateCurrentSeasonSettings {
  static readonly type = '[Season] Update Current Season Settings';

  constructor(
    public readonly settings: GenericSeasonSettings,
    public readonly seasonType: SeasonTypeEnum
  ) {}
}

export class LoadRuleSet {
  static readonly type = '[Season] Load Rule Set';

  constructor(public readonly payload: { ruleSetId: string }) {}
}

export class SetCurrentSimulation {
  static readonly type = '[Season] Set Current Simulation';

  constructor(public readonly payload: { simulationId: string; seasonType: SeasonTypeEnum }) {}
}

export class UpdateSimulation {
  static readonly type = '[Season] Update Simulation';

  constructor(public readonly payload: { simulation: SeasonSimulation; seasonType: SeasonTypeEnum }) {}
}
